import { useEffect, useState, type FormEvent } from 'react';
import { api } from '../api';
import { t } from '../i18n';
import { Link } from '../router';

export function Invite({ token }: { token: string }) {
  const [info, setInfo] = useState<{ email: string; role: string | null } | null | 'invalid'>(null);
  const [displayName, setDisplayName] = useState('');
  const [password, setPassword] = useState('');
  const [done, setDone] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.inviteInfo(token).then(setInfo).catch(() => setInfo('invalid'));
  }, [token]);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.acceptInvite(token, password, displayName);
      setDone(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : t('common.error'));
    } finally {
      setBusy(false);
    }
  };

  if (info === null) return <div className="content muted">{t('common.loading')}</div>;
  if (info === 'invalid') return <div className="form narrow card error">{t('invite.invalid')}</div>;
  if (done) {
    return (
      <div className="form narrow card">
        <p>{t('invite.done')}</p>
        <Link to="/" className="btn">{t('invite.goLogin')}</Link>
      </div>
    );
  }
  return (
    <form className="form narrow card" onSubmit={submit}>
      <h1>{t('invite.title')}</h1>
      <p className="muted">
        {t('invite.for')} <strong>{info.email}</strong>
        {info.role && <> · {t('invite.role')}: {info.role}</>}
      </p>
      <label>
        {t('invite.name')}
        <input value={displayName} onChange={(e) => setDisplayName(e.target.value)} required maxLength={80} autoComplete="name" />
      </label>
      <label>
        {t('invite.password')}
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={10} autoComplete="new-password" />
      </label>
      {error && <div className="error" role="alert">{error}</div>}
      <button className="btn" type="submit" disabled={busy}>{t('invite.submit')}</button>
    </form>
  );
}
